export default "__VITE_ASSET__b52d255c__"